import {
  call, put, select, takeLeading, all,
} from 'redux-saga/effects';
import axios from '../axiosConfig';

import {
  resendEmailRequest, resendEmailSuccess, resendEmailFailure,
  sendAgentCopyRequest, sendAgentCopySuccess, sendAgentCopyFailure,
  sendCancellationEmailRequest, sendCancellationEmailSuccess, sendCancellationEmailFailure,
} from '../../slices/trip';

function* makeRequest(config, successAction, failureAction, errorMessageProperty, payload) {
  try {
    yield call(axios, config);
    yield put(successAction(payload));
  } catch (error) {
    let errorMessage = 'Failed to send email. Please try again later.';
    if (error && error.response && error.response.data) {
      errorMessage = `${error.response.data.title} ${error.response.data.detail}`;
    }
    const errorElement = payload;
    errorElement[errorMessageProperty] = errorMessage;
    yield put(failureAction(errorElement));
  }
}

function* handleEmailRequest({
  payload, successAction, failureAction, queryParams, errorMessageProperty,
  isCancellation = false,
}) {
  const { email } = yield select((store) => store.user);

  let url = '/Email/trip';
  if (payload.brochureId) url = '/brochure/send';
  else if (payload.compareId) url = '/compare/send';
  else if (isCancellation) url = '/Email/sendcancellationemail';

  const dataPayload = {
    toEmail: (queryParams || {}).toEmail ? queryParams.toEmail : email,
    tripId: payload.tripId,
    tripSegmentId: payload.tripSegmentId,
    brochureId: payload.brochureId,
    compareId: payload.compareId,
    ...payload,
    ...(queryParams || {}),
  };
  const dataWithoutNulls = Object.fromEntries(
    Object.entries(dataPayload || {}).filter(([, v]) => v != null),
  );

  const config = {
    method: 'post',
    url,
    data: { ...dataWithoutNulls },
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };

  yield call(makeRequest, config, successAction, failureAction, errorMessageProperty, payload);
}

function* resendEmailWorker(action) {
  yield call(handleEmailRequest, {
    payload: action.payload,
    successAction: resendEmailSuccess,
    failureAction: resendEmailFailure,
    errorMessageProperty: 'sendClientCopyEmailError',
    queryParams: { doSendClientCopyEmail: true },
  });
}

function* sendAgentCopyWorker(action) {
  yield call(handleEmailRequest, {
    payload: action.payload,
    successAction: sendAgentCopySuccess,
    failureAction: sendAgentCopyFailure,
    errorMessageProperty: 'sendAgentCopyEmailError',
    queryParams: { doSendAgentCopyEmail: true },
  });
}

function* sendCancellationEmailWorker(action) {
  yield call(handleEmailRequest, {
    payload: action.payload,
    successAction: sendCancellationEmailSuccess,
    failureAction: sendCancellationEmailFailure,
    errorMessageProperty: 'cancellationEmailError',
    isCancellation: true,
  });
}

function* resendEmailWatcher() {
  yield takeLeading(resendEmailRequest.toString(), resendEmailWorker);
}

function* sendAgentCopyWatcher() {
  yield takeLeading(sendAgentCopyRequest.toString(), sendAgentCopyWorker);
}

function* sendCancellationEmailWatcher() {
  yield takeLeading(sendCancellationEmailRequest.toString(), sendCancellationEmailWorker);
}

export default function* emailRequestWatcher() {
  yield all([
    resendEmailWatcher(),
    sendAgentCopyWatcher(),
    sendCancellationEmailWatcher(),
  ]);
}
